<template>
    <section class="container min-h-full cms-layout gap-4">
        <div v-if="notFound" class="cms-document">
            <Alert variant="danger" class="my-8">
                <AlertDescription>{{ $t("ErrorPage.NotFound") }}</AlertDescription>
            </Alert>
        </div>
        <CmsDocument v-else-if="document" :document>
            <CmsPagination :pages />
        </CmsDocument>
        <CmsNavigation :navigation :root>
            <h3>
                <NuxtLinkLocale to="/blog">{{ $t("StaticSiteStrings.blog_title") }}</NuxtLinkLocale>
            </h3>
            <CmsSearch search-type="blog" :root :title="$t('StaticSiteStrings.blog_placeholder')" />
            <h4>{{ $t("StaticSiteStrings.blog_popularTags") }}</h4>
            <div class="flex gap-2 flex-wrap">
                <NuxtLink
                    v-for="tag in pagination?.tags"
                    :key="tag.path"
                    :to="tag.path"
                    class="text-sm bg-gray-200 border border-gray-300 px-2 rounded-xl">
                    {{ tag.title }}
                </NuxtLink>
            </div>
            <h4 class="mb-1">{{ $t("StaticSiteStrings.blog_recentPosts") }}</h4>
        </CmsNavigation>
    </section>
</template>
<script setup lang="ts">
const { document, navigation, pagination, pages, root, notFound } = await useCmsPage(
    "blog",
    "/blog/",
    "recent-posts.json",
    "pagination.json"
);

const { redirectUrl } = document.value ?? {};
if (redirectUrl) {
    await navigateTo(redirectUrl, { external: isValidUrl(redirectUrl), replace: true, redirectCode: 301 });
}
</script>
